<template>
  <div>
    <div class="overall-navbar" id="overall-navbar">
      <main-navigation />
      <easy-access-navbar />
    </div>

    <div>
      <slot />
    </div>
    <app-footer />
  </div>
</template>


<script>
import Footer from "../components/Footer";
import EasyAccessNavbar from "../components/EasyAccessNavbar";
import LatestUpdate from "@/components/LatestUpdate";
import MainNavigation from "../components/navigation/MainNavigation";
export default {
  components: {
    MainNavigation,
    AppFooter: Footer,
    EasyAccessNavbar,
    LatestUpdate
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
#header-logo.sticky {
  display: none !important;
}
</style>

